import { useCallback, useSyncExternalStore } from 'react';

export const FILTER_PANEL_COMMAND_ID = 'hidefilterpanel';

const getStorageKey = (gridKey: string | number) => `GRID_FILTER_ROW_VISIBLE:${gridKey}`;
const FILTER_PANEL_VISIBILITY_CHANGED = 'grid-filter-panel-visibility-changed';

export const useFilterPanelVisibility = (
  gridKey: string | number,
  enabled: boolean
): [boolean, () => void] => {
  const storageKey = getStorageKey(gridKey);
  const subscribe = useCallback((onStoreChange: () => void) => {
    window.addEventListener(FILTER_PANEL_VISIBILITY_CHANGED, onStoreChange);
    return () => window.removeEventListener(FILTER_PANEL_VISIBILITY_CHANGED, onStoreChange);
  }, []);
  const getSnapshot = useCallback(() => {
    if (!enabled) return true;
    const storedValue = localStorage.getItem(storageKey);
    return storedValue !== null && storedValue === 'true';
  }, [enabled, storageKey]);
  const visible = useSyncExternalStore(subscribe, getSnapshot, () => true);

  const toggle = useCallback(() => {
    localStorage.setItem(storageKey, String(!getSnapshot()));
    window.dispatchEvent(new Event(FILTER_PANEL_VISIBILITY_CHANGED));
  }, [getSnapshot, storageKey]);

  return [visible, toggle];
};
